import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'components/PageContent';
import { H1, P } from 'components/ui/typography.tsx';

export const NoFlightOffer = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <PageContent>
        <div className='flex flex-col gap-6'>
          <H1>{t('flightOffer.offer')}</H1>
          <P className='text-lg font-[MuseoSansCyrl] mt-12'>{t('noFlightOffer.noOffersToDisplay')}</P>
        </div>
      </PageContent>
    </Fragment>
  );
};
